import React from 'react';
import './index.css';

const CandleSticksChartCurrentPrice: React.FC<any> = (props: any) => {
  const {
    y,
    length,
    index,
    currentPrice,
    handleZoomIn,
    chartWidth,
    paddingRight,
  } = props;

  if (index !== length - 1) {
    return null;
  }

  return (
    <svg
      width="100%"
      height="100%"
      x={chartWidth - paddingRight}
      y={y - 14}
      onClick={handleZoomIn}
      style={{ cursor: 'pointer' }}
    >
      <rect
        fill="#242424"
        width={20 + currentPrice.toString().length * 9}
        height="29"
        opacity={0.9}
      ></rect>
      <text x="12" y="20" fontSize="18" fill="white">
        {currentPrice}
      </text>
    </svg>
  );
};

export default React.memo(CandleSticksChartCurrentPrice);
